import { TabPanel, TabView } from 'primereact/tabview'
import React from 'react'
import Overall from './DashboardTabs/Overall'
import PRSData from './DashboardTabs/PRSData'
import HCWData from './DashboardTabs/HCWData'

const Dashboard = () => {
  return (
    <div className="container">
      <span className="heading-page mt-0">Dashboard</span>

              <TabView scrollable className='mt-4 dashbpard-theme'>
                <TabPanel header="Over All">
                  <Overall/>
                </TabPanel>

                <TabPanel header="PRS">
                  <PRSData/>
                </TabPanel>

                <TabPanel header="HCW">
                  <HCWData/>
                </TabPanel>

        </TabView>
    </div>
  )
}

export default Dashboard
